// /login — the desk entry screen: a depth-1 wire over the module-owned form
// (Law F1; @erp/module-auth/fe/sign-in carries the opaque-denial discipline,
// the step-up branch and the human check). Only the desk's copy lives here.
import { LogIn } from "lucide-solid";
import { SignInScreen } from "@erp/module-auth/fe/sign-in";

export function LoginScreen() {
  return (
    <SignInScreen
      title="Library Desk"
      subtitle="Sign in to the circulation desk."
      emailHint="The desk account address your library issued — personal mailboxes are not linked to a desk."
      passwordHint="Case-sensitive. Sign-in failures never say which factor was wrong, so re-check both before retrying."
      icon={LogIn}
    />
  );
}
